<template>
  <div class="search-results-list" role="region" aria-label="Search Results">
    <div class="search-results-group" v-if="suggestions.length">
      <h2 class="h4 uppercase">Popular Suggestions</h2>
      <ul class="results">
        <li v-for="s in suggestions">
          <a href="#" @click.prevent="setCurrentQuery(s)" class="link p1" :key="s" v-html="s"></a>
        </li>
      </ul>
    </div>

    <div class="search-results-group" v-if="categories.length">
      <h2 class="h4 uppercase">Categories</h2>
      <ul class="results">
        <li v-for="s in categories">
          <a :href="s.link" class="link p1" :key="s.category_id" v-html="s.title"></a>
        </li>
      </ul>
    </div>

    <div class="search-results-group" v-if="pages.length">
      <h2 class="h4 uppercase">Articles</h2>
      <ul class="results" v-for="s in pages">
        <li>
          <a :href="s.link" class="link p1" :key="s.page_id" v-html="s.title"></a>
        </li>
      </ul>
    </div>

    <div class="search-results-group products" v-if="products.length">
      <h2 class="h4 uppercase">Products</h2>
      <ul class="results">
        <li v-for="product in products">
          <a :href="product.link" class="search-results-product f" :key="product.product_id">
            <div class="image ratio ro-1 fit-contain">
              <img class="img__el img" :src="product.image_link" alt="">
            </div>
            <div class="details">
              <h3 class="h5" v-html="product.title"></h3>
            </div>
          </a>
        </li>
      </ul>
    </div>

    <div>
      <a :href="`/pages/search-results-page?q=${state.searchAttributes.q}`" class="btn btn--primary btn--full-width" v-if="state.searchResults.totalItems">
        <span class="button__el">View All Results</span>
      </a>
    </div>
  </div>
</template>

<script>
import state from 'lib/appState'
import select from 'dom-select'

export default {
  data () {
    return {
      state
    }
  },
  methods: {
    setCurrentQuery (s) {
      window.Searchanise.$('[name="q"]').val(s)
      window.Searchanise.$('[name="q"]').focus().change()
    },
    activeResultsTabs () {
      const resultsTab = select('#snize_results')
      const resultsTabList = select('.snize-main-panel-controls-products')
      console.log(resultsTabList)
      if (resultsTab && resultsTabList) {
        resultsTabList.map((tab) => {
          const tabIndex = resultsTabList.indexOf(tab)
          console.log(tabIndex)
        })
      }
    }
  },
  computed: {
    suggestions () {
      return this.state.searchResults.suggestions ? this.state.searchResults.suggestions : []
    },
    categories () {
      return this.state.searchResults.categories ? this.state.searchResults.categories : []
    },
    pages () {
      return this.state.searchResults.pages ? this.state.searchResults.pages : []
    },
    products () {
      return this.state.searchResults.items ? this.state.searchResults.items : []
    }
  },
  mounted() {
    setTimeout(() => (this.activeResultsTabs()), 1000)
  }
}
</script>
